import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconPercent = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--percent")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M17.5,14 C19.4329966,14 21,15.5670034 21,17.5 C21,19.4329966 19.4329966,21 17.5,21 C15.5670034,21 14,19.4329966 14,17.5 C14,15.5670034 15.5670034,14 17.5,14 Z M18.2928932,4.29289322 C18.6834175,3.90236893 19.3165825,3.90236893 19.7071068,4.29289322 C20.0976311,4.68341751 20.0976311,5.31658249 19.7071068,5.70710678 L19.7071068,5.70710678 L5.70710678,19.7071068 C5.31658249,20.0976311 4.68341751,20.0976311 4.29289322,19.7071068 C3.90236893,19.3165825 3.90236893,18.6834175 4.29289322,18.2928932 L4.29289322,18.2928932 Z M17.5,16 C16.6715729,16 16,16.6715729 16,17.5 C16,18.3284271 16.6715729,19 17.5,19 C18.3284271,19 19,18.3284271 19,17.5 C19,16.6715729 18.3284271,16 17.5,16 Z M6.5,3 C8.43299662,3 10,4.56700338 10,6.5 C10,8.43299662 8.43299662,10 6.5,10 C4.56700338,10 3,8.43299662 3,6.5 C3,4.56700338 4.56700338,3 6.5,3 Z M6.5,5 C5.67157288,5 5,5.67157288 5,6.5 C5,7.32842712 5.67157288,8 6.5,8 C7.32842712,8 8,7.32842712 8,6.5 C8,5.67157288 7.32842712,5 6.5,5 Z" id="icon--centivo--percent"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1862.000000, -860.000000)"/>
          <g id="Icon/percent">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--percent"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--percent"/>
          </g>
      </g>
  </IconWrapper>
)
